import { render, staticRenderFns } from "./PlatformNotices.vue?vue&type=template&id=04854105&scoped=true&"
import script from "./PlatformNotices.vue?vue&type=script&lang=js&"
export * from "./PlatformNotices.vue?vue&type=script&lang=js&"
import style0 from "./PlatformNotices.vue?vue&type=style&index=0&id=04854105&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04854105",
  null
  
)

export default component.exports